"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.localString = void 0; // 
// Translate strings into different languages 
// Then use localString(id) to return the language specific string to use
//

var strings = {
  en: {
    OpenRepo: "Go to Repo",
    StringMissing: "String Id missing",
    LangNotSupported: "Language not supported"
  }
};

var localString = function localString(id) {
  var lang = navigator.language.split(/-|_/)[0]; // if language is unknown (not sure this can actually happen)

  if (lang === undefined) {
    lang = 'en';
  } // if there are no strings for the language


  if (strings[lang] === undefined) {
    lang = 'en';
    return strings[lang]['LangNotSupported'];
  }

  var lstring = strings[lang][id]; // if a string for the message id is missing

  if (lstring === undefined) {
    return strings[lang]['StringMissing'];
  }

  return lstring;
};

exports.localString = localString;